import React, { useState, useContext, createRef, useEffect } from 'react';
import { Header, Checkbox, Container, Segment, Sticky, Grid, Input, Transition, Divider, Loader } from 'semantic-ui-react';
import { Button, Form, Icon, List, Dimmer } from 'semantic-ui-react';
import { Link, Redirect } from 'react-router-dom';
import { AppState } from '../context';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { dbFamMember, dbCaregivers, dbTasks } from '../firebase';
import TopMenu from './TopMenu';
import Name from './ProfileCreation/Name';
import TaskList from './CaregiverTasks';
import LoginGBL from './LoginGBL';
import LoginForm from './LoginGB';


const HomePageFamilyMember = () => {
  const someContext = useContext(AppState);
  const [loader, setLoader] = useState(true);
  setTimeout(() => { setLoader(false) }, 500)

  const {
    globallogged,
    setGlobalLogged,
    logged,
    setLogged,
    user,
    firsttimeuser,
    setFirsttimeuser,
    setUser,
    familyMembers,
    tasks,
    name,
    setName,
    seniors,

  } = someContext;
  const contextRef = createRef();
  const uiConfig = {
    signInFlow: 'popup',
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID

      // Add authentication with Facebook and Email once the app has been hosted.
      // Uncomment the lines below for incoporating Facebook and Email.


      // firebase.auth.EmailAuthProvider.PROVIDER_ID,
      // firebase.auth.FacebookAuthProvider.PROVIDER_ID
    ],
      callbacks: {
        signInSuccessWithAuthResult: (authResult, redirectUrl) => {
          console.log(authResult, redirectUrl)
          return <Redirect to={`/familyMembers`}/>;
        }
    }
  };
  const sendText = firebase.functions().httpsCallable('sendText');


  function sendSMS(taskID) {

    var number2 = "";
    dbTasks.child(taskID).once('value').then(function (temp) {
      var taskname = temp.val().taskName
      var duration = temp.val().duration
      var description = temp.val().description;
      var time = temp.val().time;
      var importance = temp.val().importance;
      var freq = temp.val().frequency;


      var c = "Task: " + taskname + " at approximately " + time + "Approximate Duration: " + duration + "Description: " + description + "Importance: "
        + importance + "Frequency: " + freq;
      console.log(c)

      dbCaregivers.child(temp.val().caregiverId).child("phone").once("value", function (snapshot) {
        number2 = snapshot.val()

      }, function (errorObject) {
        console.log("The read failed: " + errorObject.code);
      });
      let tempe = { to: number2, body: c };
      console.log(tempe)
      sendText({ data: tempe });
    });
  }

  // useEffect(() => {
  //   //HERE
  //   // firebase.auth().onAuthStateChanged(function (val) {
  //   //   if (val) {
  //   //     dbFamMember.orderByChild("id").equalTo(val["uid"]).once("value", snapshot => {
  //   //       if (snapshot.exists()) {
  //   //         const userData = snapshot.val();
  //   //         setFirsttimeuser(false)
  //   //       }
  //   //       else {
  //   //         setFirsttimeuser(true)
  //   //       }
  //   //     })
  //   //   }
  //   //   setUser(val)
  //   // });

  //   if (globallogged)
  //   {
  //     setFirsttimeuser(false)
  //   }
  //   else{
  //     setFirsttimeuser(true)
  //   }
  // }, []);

  const PageHeader = () => {
    return (
      <Segment
        basic
        style={{ backgroundColor: "#006990", textAlign: "center", marginBottom: "0px" }}
        fluid="true"
      >
        <Grid columns={2}>
          <Grid.Column width='3' />
          <Grid.Column width='10'>
            <Header
              as={Link}
              to="/"
              inverted
              content="Homecare"
              size="large"
              color="black"
              style={{ cursor: "default" }}
            />
          </Grid.Column>
        </Grid>
      </Segment>
    );
  };

  function Greeting({ userID }) {
    function helper(idList) {
      var returnable = ""
      for (let i = 0; i < idList.length; i++) {
        var temp = seniors ? seniors[idList[i]]["firstName"] : ""
        returnable = returnable + temp
        console.log(temp)
        console.log(returnable)
      }
      return returnable
    }

    return (
      <Grid.Row>
        {familyMembers ? <Header as='h3'> {" " + helper(familyMembers[userID]["seniors"])} </Header> : ""}
        <Divider hidden />
      </Grid.Row>
    );
  }

  function Tasks({ userID }) {
    const [taskidlist, setTaskidlist] = useState([]);

    useEffect(() => {
      const handleClose = () => {
        if (familyMembers && familyMembers[userID] && familyMembers[userID]["tasks"]) {
          let a = familyMembers[userID]["tasks"];
          const result = Object.values(a);
          setTaskidlist(result);
        }
      };
      handleClose();
    }, []);


    function Update_click(status) {
      if (tasks) {
        let new_status = !tasks[status.input]["status"];
        dbTasks.child(status.input).update({
          "status": new_status,
          "statusLastChecked": { '.sv': 'timestamp' }
        })
      }
    }

    function Remove_click(status) {
      if (tasks) {
        if (Object.keys(familyMembers[userID]["tasks"]).length > 1) {
          dbFamMember.child(userID).child("tasks").child(status.input).remove();
          // Removes the task from the Task database.
          dbTasks.child(status.input).remove();
        }
      }
    }

    function helper1(input) {

      if (tasks && familyMembers && input && tasks[input] && !tasks[input]["status"]) {
        return (
          <List.Item>
            <List.Icon>
              <Checkbox checked={tasks[input]["status"]} onClick={() => Update_click({ input })} />
            </List.Icon>
            <List.Content>
              <List.Description>
                <Button icon="close" size="mini" floated="right" onClick={() => Remove_click({ input })}>
                </Button>
                <Button icon="share" size="mini" floated="right" onClick={() => sendSMS(input)}>
                </Button>
              </List.Description>
              <a href={`/familymembers/edit/${input}`}><List.Header as="a">{tasks[input]["taskName"] + ":"}</List.Header>
                <List.Description as="a"> At  {tasks[input]["time"]} </List.Description>
                <List.Description as="a">{tasks[input]["description"]} <strong>{tasks[input]["importance"]} Importance </strong></List.Description>
              </a></List.Content>
          </List.Item>
        )
      }
      else {
        return null;
      }
    }
    function helper2(input) {

      if (tasks && familyMembers && input && tasks[input] && tasks[input]["status"]) {
        return (
          <List.Item>
            <List.Icon>
              <Checkbox checked={tasks[input]["status"]} onClick={() => Update_click({ input })} />
            </List.Icon>
            <List.Content>
              <List.Description>
                <Button icon="close" size="mini" floated="right" onClick={() => Remove_click({ input })}>
                </Button>
              </List.Description>
              <a href={`/familymembers/edit/${input}`}><List.Header as="a">{tasks[input]["taskName"] + ":"}</List.Header>
                <List.Description as="a"> At {/*tasks[input]["seniorFirstName"]*/}
                  {tasks[input]["time"]} </List.Description>
                <List.Description as="a">{tasks[input]["description"]} <strong>{tasks[input]["importance"]} Importance </strong></List.Description>
              </a></List.Content>
          </List.Item>
        )
      }
      else {
        return null;
      }
    }
    return (
      <Container>
        <Transition.Group
          as={List}
          duration={1000}
          divided
          relaxed
          verticalAlign='middle'
        >
          {familyMembers ? taskidlist.map((input) => helper1(input)) : ""}
          {familyMembers ? taskidlist.map((input) => helper2(input)) : ""}
        </Transition.Group>
      </Container>
    );
  }

  function ActualPage({ user }) {
    return (
      <Container>
        <TaskList userID={user} />
      </Container>
    );
  }

  function SignedIn({ user }) {
      if(globallogged){
      return (
        <div>
          <TopMenu />
          <Container>
            <Container>
              <Grid.Row>
                <Header as="h4" style={{ fontWeight: "normal", fontSize: "18px", marginTop: "30px" }}>
                  {"My tasks"}
                </Header>
              </Grid.Row>
              <Grid centered key={'content'} style={{ marginTop: "-0px" }}>
                <Grid.Row>
                  <Grid.Column>
                    <ActualPage user={user} />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Button padded floated="center" content="Add a task" circular icon='add' as={Link} to={`/familymembers/${user}`} />
                </Grid.Row>
              </Grid>
            </Container>
          </Container>
        </div>
      )
      }
      else{
        return <Redirect to={`/viewfamily/${user}`} push={true} />
      }
  }

  function NotSignedIn() {
    return (
      <Redirect to={'/login'} push={true} />
    )
  }
  return (
    loader ?
      <Dimmer active>
        <Loader size='huge'>Loading</Loader>
      </Dimmer>
      :
      <div>
        {user ? <SignedIn user={user} /> : <NotSignedIn />}
      </div>
  );
};

export default HomePageFamilyMember;
